import { useMemo } from 'react'

import type { DistributionUserResponse } from '#/shared/api/generated/shipment/models'
import { useListDistributionUsersApiV1DistributionsUsersGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { UserOption } from '#/shared/ui/user-dropdown'

function toOption(user: DistributionUserResponse): UserOption {
  const name = [user.first_name, user.last_name]
    .filter(Boolean)
    .join(' ')
    .trim()
  return {
    id: user.id,
    name: name || user.email,
    avatarUrl: user.picture ?? undefined,
  }
}

// Users currently eligible to receive work: active distribution row + active
// account. Deliberately narrower than `/shipments/teams` — a user without a
// distribution row must not be offered as a reassign target even if they hold
// order/lead permissions. The response is complete (unpaginated), sorted by
// name, and already includes the caller.
//
// The reassign surfaces are mounted long before anyone reassigns, so callers
// gate the fetch on the menu that shows the list actually opening, and render
// `isLoading` as skeleton rows for the first-open beat.
export function useDistributionUsers(enabled = true): {
  users: UserOption[]
  isLoading: boolean
} {
  const { data, isLoading } =
    useListDistributionUsersApiV1DistributionsUsersGet(undefined, {
      query: { enabled },
    })
  const users = useMemo(() => (data?.data ?? []).map(toOption), [data])
  return { users, isLoading }
}
